// ------------------ Import Modules---------------------
import authController from './modules/auth/authController.js';
import coreRouter from './modules/core/coreRouter.js';

// ------------------ Global Variables ------------------
window.appLanguage = null;

// ------------------ Helper Functions ------------------
/**
 * Remove all conditional navigation comments for admin panel
 * Admins should see all navigation items without filtering
 */
function cleanNavigationComments() {
  const navContainer = document.getElementById('app-nav');
  if (!navContainer) return;

  // Get all HTML comments in the navigation
  const walker = document.createTreeWalker(
    navContainer,
    NodeFilter.SHOW_COMMENT,
    null,
    false
  );

  const comments = [];
  let currentNode;

  while (currentNode = walker.nextNode()) {
    comments.push(currentNode);
  }

  // Remove all conditional comment markers (IF:module, /IF:module)
  // Keep all navigation content visible for admins
  comments.forEach(comment => {
    const text = comment.textContent.trim();
    if (text.match(/^IF:\w+$/) || text.match(/^\/IF:\w+$/)) {
      comment.remove();
    }
  });
}

// ------------------ Initial Loader --------------------
async function bootstrapApp() {
  await authController.init();

  // Check if user is authenticated
  const isAuthenticated = await authController.isAuthenticated();

  if (isAuthenticated) {
    // Admin panel: Show all navigation items without filtering
    cleanNavigationComments();
  }

  await coreRouter.init();
}

// ------------------ Execute on Load -------------------
window.onload = bootstrapApp;